import { render, staticRenderFns } from "./calc.vue?vue&type=template&id=4c4e0340&scoped=true"
import script from "./calc.vue?vue&type=script&lang=js"
export * from "./calc.vue?vue&type=script&lang=js"
import style0 from "./calc.vue?vue&type=style&index=0&id=4c4e0340&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4e0340",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VContainer,VIcon})
